import React from 'react';
import { Bell, Menu } from '../../../components/ui/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DashNavbar = ({ toggleSidebar, isOpen }) => {
  const { t } = useTranslation();
  return (
    <nav className="fixed top-0 right-0 left-0 z-30 h-18 border-b border-gray-200 bg-white px-4 lg:left-64 lg:px-6">
      <div className="flex h-full items-center w-full">
        {/* Mobile logo on left */}
        <div className="flex items-center gap-2 lg:hidden">
          <Link to="/" onClick={() => window.scrollTo(0,0)}>
            <img
              src="/image/logo.png"
              alt="TrustSurgery logo"
              loading="eager"
              decoding="async"
              width="32"
              height="32"
              className="h-8"
            />
          </Link>
        </div>

        <div className="flex-1" />

        {/* Menu button (mobile) and avatar (desktop) aligned to right */}
        {!isOpen && (
          <button
            onClick={toggleSidebar}
            className="rounded-md p-1 text-gray-800 hover:bg-gray-100 lg:hidden"
            aria-label={t('dash.sidebar.openSidebar')}
          >
            <Menu size={28} />
          </button>
        )}

        <div className="hidden items-center gap-4 lg:flex lg:gap-6">
          <div className="flex items-center gap-2 lg:gap-3">
            <img
              src="https://ui-avatars.com/api/?name=Atik+Adnan&background=0ea5e9&color=fff"
              alt="Atik Adnan"
              loading="lazy"
              decoding="async"
              width="40"
              height="40"
              className="h-8 w-8 rounded-full lg:h-10 lg:w-10"
            />
            <div className="flex flex-col">
              <span className="text-sm leading-none font-semibold text-gray-900">Atik Adnan</span>
              <span className="text-xs text-gray-500">{t('dash.common.admin')}</span>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default DashNavbar;
